let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b2zon")).then(() => parcelRequire('3hjAC'));